import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function RoleChange({ userData, fetchUser, setShowRole }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [role, setRole] = useState(userData.role)

  async function changeRole() {
    const data = {
      role: role,
    }
    if (role.length < 4) {
      notify('warn', 'Pick a role')
      return
    }
    setCancelLoading(true)
    put(`admin/change-admin-role/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Admin role Updated')
          setShowRole(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Change Admin Role</h1>
        <p>Note: this will change the admin role and their access</p>
        <select
          name=''
          id=''
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value=''>-select-</option>
          <option value='agent'>Agent</option>
          <option value='customer service'>Customer Service</option>
          <option value='manager'>Manager</option>
          <option value='super admin'>Super Admin</option>
        </select>
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowRole(false)}>Cancel</button>
            <button className='proceed' onClick={changeRole}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default RoleChange
